import { GeoJSON } from "react-leaflet";
import { GeoJsonGeometry } from "../../../services/RuteplanAPI";

export interface IRoadFeatureLineProps {    
    data: GeoJsonGeometry,
}

export default function RoadFeatureLine(props: IRoadFeatureLineProps) {
    
    return(
        <>
        {props.data && props.data.type && (
            <>
            <GeoJSON
                key={props.data.type + Math.random()}
                data={props.data}
                style={{ color: "#00000000", weight: 3 }}
            />
            <GeoJSON
                key={props.data.type + Math.random()}
                data={props.data}
                style={{ color: "#33ff00ff", weight: 3 }}
            />
            </>
        )}
        
        </>
    )
}